/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const modulesMetaAdDataInputTargetingOptionsDataSchema = z.object({
	cities: z.array(z.object({ id: z.string(), radius: z.number() })).nullable().optional(),
	countries: z.array(z.object({ id: z.string() })).nullable().optional(),
	interests: z.array(z.object({ id: z.string() })).nullable().optional(),
})

export type ModulesMetaAdDataInputTargetingOptionsDataSchema = z.infer<
	typeof modulesMetaAdDataInputTargetingOptionsDataSchema
>
